import React from "react";
import { Button } from "@/components/ui/button";
import { Power, PowerOff, X } from "lucide-react";

/**
 * Contextual action bar that shows above the users table when the admin
 * has ticked at least one row. Renders nothing otherwise.
 */
export function BulkActions({ count, disabled, onActivate, onDisable, onClear }) {
  if (count === 0) return null;
  return (
    <div
      className="p-3 border-b border-orange-200 bg-orange-50 flex items-center gap-3 flex-wrap"
      data-testid="bulk-actions-bar"
    >
      <div className="flex items-center gap-2 flex-1 min-w-[200px]">
        <div className="w-7 h-7 rounded-md bg-orange-600 text-white flex items-center justify-center text-xs font-bold">
          {count}
        </div>
        <div className="text-sm text-slate-800 font-medium">
          usuario{count === 1 ? "" : "s"} seleccionado{count === 1 ? "" : "s"}
        </div>
      </div>
      <Button
        size="sm" variant="outline"
        onClick={onActivate}
        disabled={disabled}
        className="border-emerald-200 text-emerald-700 hover:bg-emerald-50"
        data-testid="bulk-activate-btn"
      >
        <Power className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.75} />
        Activar
      </Button>
      <Button
        size="sm"
        onClick={onDisable}
        disabled={disabled}
        className="bg-red-600 hover:bg-red-700 text-white"
        data-testid="bulk-disable-btn"
      >
        <PowerOff className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.75} />
        Desactivar
      </Button>
      <Button
        size="sm" variant="ghost"
        onClick={onClear}
        disabled={disabled}
        className="text-slate-600 hover:text-slate-900"
        data-testid="bulk-clear-btn"
      >
        <X className="w-3.5 h-3.5 mr-1" strokeWidth={1.75} />
        Limpiar
      </Button>
    </div>
  );
}
